/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelCodeCompIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelCodeCompIcon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M33.7257 14.116C32.9646 13.6879 32.0354 13.6879 31.2743 14.116L17.2743 21.991C16.4872 22.4338 16 23.2667 16 24.1699V39.8305C16 40.7337 16.4872 41.5667 17.2743 42.0095L31.2743 49.8845C32.0354 50.3125 32.9646 50.3125 33.7257 49.8845L38 47.4801V46.3328L33 49.1453V32.2927L48 23.8551V33H49V24.1699C49 23.2667 48.5128 22.4338 47.7257 21.991L33.7257 14.116ZM31.7646 14.9876C32.2212 14.7307 32.7788 14.7307 33.2354 14.9876L47.4801 23.0002L32.5 31.4265L17.5199 23.0002L31.7646 14.9876ZM17 23.8551L32 32.2927V49.1453L17.7646 41.1379C17.2923 40.8722 17 40.3724 17 39.8305V23.8551Z"
              fill="currentColor"
            />
            <path
              d="M45.9846 36L43 47.9384V48H44.0154L47 36.0616V36H45.9846Z"
              fill="currentColor"
            />
            <path
              d="M41.8536 44.1465L39.7072 42.0001L41.8536 39.8537L41.1465 39.1465L38.293 42.0001L41.1465 44.8537L41.8536 44.1465Z"
              fill="currentColor"
            />
            <path
              d="M50.293 42.0001L48.1465 44.1465L48.8536 44.8537L51.7072 42.0001L48.8536 39.1465L48.1465 39.8537L50.293 42.0001Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelCodeCompIcon.tags = [
  'code',
  'development',
  'cube',
  'components',
  'programming',
];

AddPanelCodeCompIcon.category = '64x64 (Add panel)';

AddPanelCodeCompIcon.iconSize = 64;
